import { OriginatorDisplayNamesHeyLight } from '../constants';
import { OriginatorDisplayKeysHeyLight } from '../types';

export const getOriginatorDisplayNameHeyLight = (originator: string) =>
  OriginatorDisplayNamesHeyLight[originator as OriginatorDisplayKeysHeyLight] ??
  originator;
